import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "menuButton"];

  toggleMenu() {
    this.menuTarget.classList.toggle("md:hidden");
    this.menuTarget.classList.toggle("hidden");
  }

  // Close menu when clicking outside
  connect() {
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  handleClickOutside(event) {
    if (!this.menuButtonTarget.contains(event.target)) {
      this.menuTarget.classList.add("md:hidden");
      this.menuTarget.classList.add("hidden");
    }
  }
}
